import {
  isBetweenOperator,
  isBetweenValueComplete,
  isOperatorValueRequired,
  normalizeFilterValue,
} from './conditionBuilderUtils';
import {
  FILTER_VALUE_TYPE_FIELD,
  FILTER_VALUE_TYPE_LITERAL,
  getFilterValueType,
} from './filterFieldValueUtils';
import {
  isDateOrDateTimeFieldType,
  validateDateFilterBetweenLiteralValue,
  validateDateFilterLiteralValue,
} from './dateLiteralUtils';

/** Map ConditionRow operators to report filter / SQL operator keys (same as FieldSelector). */
export function fromConditionRowOperator(op) {
  if (!op) return 'equals';
  if (op === 'greater_than_or_equal') return 'greater_equal';
  if (op === 'less_than_or_equal') return 'less_equal';
  return op;
}

/** Map stored report filter operators to ConditionRow operator keys. */
export function toConditionRowOperator(op) {
  if (!op) return 'equals';
  if (op === 'greater_equal') return 'greater_than_or_equal';
  if (op === 'less_equal') return 'less_than_or_equal';
  return op;
}

/** True when a filter row is ready for preview / persist (field + value when required). */
export function isCompleteReportFilter(filter) {
  if (!filter) return false;
  const fieldId = filter.field_config_id;
  const fieldName = filter.field_name;
  if (
    fieldId == null ||
    fieldId === '' ||
    !fieldName ||
    String(fieldName).trim() === ''
  ) {
    return false;
  }
  const op = filter.operator || 'equals';
  if (!isOperatorValueRequired(toConditionRowOperator(op))) {
    return true;
  }
  const rowOp = toConditionRowOperator(op);
  if (isBetweenOperator(rowOp)) {
    return isBetweenValueComplete(filter.value);
  }
  const valueType = getFilterValueType(filter);
  if (valueType === FILTER_VALUE_TYPE_FIELD || valueType === 'field') {
    const v = filter.value;
    return v != null && String(v).trim() !== '';
  }
  const v = filter.value;
  if (v == null || String(v).trim() === '') return false;
  if (
    (valueType === FILTER_VALUE_TYPE_LITERAL || valueType === 'literal') &&
    isDateOrDateTimeFieldType(filter.data_type)
  ) {
    if (isBetweenOperator(rowOp)) {
      return validateDateFilterBetweenLiteralValue(v).valid;
    }
    return validateDateFilterLiteralValue(v).valid;
  }
  return true;
}

export function getCompleteReportFilters(filters) {
  return (filters || []).filter(isCompleteReportFilter);
}

export function normalizeReportFilterForApi(filter, index = 0) {
  const fieldName =
    typeof filter.field_name === 'string' ? filter.field_name.trim() : filter.field_name;
  const operator =
    typeof filter.operator === 'string'
      ? filter.operator.trim() || 'equals'
      : filter.operator || 'equals';
  return {
    id: filter.id,
    field_config_id: filter.field_config_id,
    field_name: fieldName,
    field_label: filter.field_label,
    data_type: filter.data_type,
    object_name: filter.object_name,
    operator,
    value: normalizeFilterValue(filter.value ?? ''),
    valueType: getFilterValueType(filter),
    is_editable: filter.is_editable !== false,
    order_no: filter.order_no || index + 1,
  };
}
